import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import Rate from "./components/Rate";
import RateSettings from "./components/RateSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/rate_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'rate',
    group: ElementGroup.SELECT,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_RATE'],
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        allowClear: true,
        allowHalf: true,
        count: 5
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_RATE']
      },
      settings: {
        width: {
          value: "100%"
        },
      }
    },
    pluginComponent: Rate, // 插件渲染组件
    pluginSettingComponent: RateSettings, // 插件设置项组件
  }
}
